import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './InputError.module.scss';
import cn from 'classnames';
const InputError = ({ errors, inputName, trade }) => {
    return (_jsx("span", Object.assign({ className: cn(styles.element, trade && styles['isTrading'], 'd-inline-flex align-items-center') }, { children: errors[inputName] })));
};
export default InputError;
